import { render, staticRenderFns } from "./UcProductPrices.yaml?vue&type=template&id=8be5b37c&component"
import script from "./UcProductPrices.yaml?vue&type=script&lang=ts&component"
export * from "./UcProductPrices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports